import React from 'react';

class Footer extends React.Component {
  render() {
    return (
		<div className="span12">										
			<div className="footer-wrapper">
				<ul className="nav nav-pills nav-fill nav-justified-footer-links">
                    {window.env.FOOTER_LINK_LABELS.split(',').map((label, index) => (<li className="dropdown"><a href={window.env.FOOTER_LINK_URLS.split(',')[index]} target="Amstock" className=" twMenu">{label}</a></li>))}
				
              	{/* <div className="copyright-area col-sm-12">
              		<h5 className="copyright">© {(new Date().getFullYear())}
                	{window.env.BUSINESS_LINE=='ast' ? ' American Stock Transfer & Trust Company, LLC. ':' AST Trust Company (Canada). '}                	 
                	 All rights reserved.</h5>                	
              	</div> */}
				</ul>
				{/* <ul className="nav nav-pills nav-fill nav-justified-copyright-link">
					<li class="dropdown"><a class=" twMenu"></a></li>  
				</ul> */}
				<ul className="nav nav-pills nav-fill nav-justified-footer-links">
					<li class="dropdown"><a class=" twMenu">© {(new Date().getFullYear())} Equiniti Trust Company, LLC. All rights reserved.</a></li>
				</ul>
			</div>
		</div>
    );
  }
}

export default Footer;